import { memo } from "react";
import { Modal, Form } from "react-bootstrap";
import Axe from "../../../assets/images/sidebar/icons/axeMark.svg";


const EditPlanTask = memo((props) => {

    const { isEditTask, setIsEditTask } = props

    return (
        <Modal
            size="xl"
            show={isEditTask}
            aria-labelledby="modal-90w"
            onHide={() => setIsEditTask(false)}
            className="add-task-modal-main"
            centered
        >
            <Modal.Header className="add-task-modal-header">
                <Modal.Title id="example-modal-sizes-title-lg">
                    Edit Task
                </Modal.Title>

                <div className="rightAxe">
                    <img src={Axe} alt="close"
                        onClick={() => setIsEditTask(false)}
                    />
                </div>
            </Modal.Header>

            <div className="lineSeperate"></div>

            <Form noValidate>
                <Modal.Body>
                    <div className="mainContentmodel">
                        <div className="row add-task-modal-inputs" id="popup-form-af">

                            {/* Project */}
                            <div className="col-lg-6">
                                <label className="mb-2">Project</label>
                                <select className="form-select tasKCategory1 mb-2">
                                    <option value="">Select Project</option>
                                    <option value="1">Example Project 1</option>
                                    <option value="2">Example Project 2</option>
                                </select>
                                <div className="invalid-feedback">Please select project</div>
                            </div>

                            {/* Task */}
                            <div className="col-lg-6">
                                <label className="mb-2">Task</label>
                                <input
                                    type="text"
                                    placeholder="Enter your activity here..."
                                    className="form-control tasKCategory1 mb-2"
                                    maxLength={65}
                                />
                                <div className="invalid-feedback">Please enter task</div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>

                <div className="lineSeperate"></div>

                {/* Bottom Buttons */}
                <div className="d-flex justify-content-end align-items-center mainBtnsSub">
                    <button type="button" className="btn-width cancelBtn mx-3"
                        onClick={() => setIsEditTask(false)}
                    >
                        Cancel
                    </button>

                    <button className="btn-width saveBtn"

                    >
                        Update
                    </button>
                </div>
            </Form>
        </Modal>
    )

})

export default EditPlanTask